import React,{useState, useEffect} from 'react'
import $ from 'jquery';
import { environment } from '../environment/production';
import axios from 'axios';

function WorkExperience(props) {
  const [minFromDate,setMinFromDate]=useState(new Date())
  const [maxFromDate,setMaxFromDate]=useState(new Date())
  const [minToDate,setMinToDate]=useState(new Date())
  const [maxToDate,setMaxToDate]=useState(new Date())
  let i=1
  let [initialization,setInitialization]=useState(1)
  let [initializationACP,setInitializationACP]=useState(1)
  let [initializationLoad,setInitializationLoad]=useState(1)
  let [datalength,setDataLength]=useState(1)
  const [createEduStatus,setCreateEduStatus]=useState('0')
  const [data,setData]=useState({
  
    data:'',
    university_name:'',
    degree:'',
    year_of_passing:'',
    marks_obtained:'',
    subject_specialization:''
  })
  const [formdata,setFormData]=useState({
    user_id:parseInt(sessionStorage.getItem("user_id")),
    date_of_initial_appointment:'',
    period_of_appointment:'',
    office_applicant_belongs:'',
    name_and_pay_of_post:'',
    last_deputation_detail:'',
    nature_of_present_employment:'',
    addtnl_dtls_about_present_employment:'',
    addtnl_dtls_about_prsnt_employer_name:'',
    addtnl_dtls_about_present_employment_other:'',
    additional_information:'',
    state_deputation_absorption:'',
    sc_st_category:''

  })
  const [formdataCreateDetailsEmployment,setFormDataCreateDetailsEmployment]=useState({
    user_id:parseInt(sessionStorage.getItem("user_id")),
    office_name:'',
    post_held:'',
   employment_from:'',
   employment_to:'',
   scale_of_pay:'',
   nature_of_duties:''

  })

  const [formdataCreateACPDetailsEmployment,setFormDataCreateACPDetailsEmployment]=useState({
    user_id:parseInt(sessionStorage.getItem("user_id")),
    acp_office_name:'',
    acp_post_held:'',
    acp_from:'',
    acp_to:'',
  })

  const [apiCall,setApiCall]=useState(0)
  const options={
    data:{
      formdata
    },
    headers:{
      'Authorization':sessionStorage.getItem("access_token")
    }
  }

  const CreateDetailsEmployment=()=>{
   
    if(formdataCreateDetailsEmployment.office_name!=='' && formdataCreateDetailsEmployment.post_held!=='' && formdataCreateDetailsEmployment.employment_from!=='' && formdataCreateDetailsEmployment.employment_to!=='' && formdataCreateDetailsEmployment.scale_of_pay!=='' && formdataCreateDetailsEmployment.nature_of_duties!==''){
      axios.post(environment.apiUrl+"/Experience/CreateDetailsEmployment",JSON.stringify(formdataCreateDetailsEmployment),{headers:(options.headers)})
      .then((response)=>{
        console.log("CreateDetailsEmployment")
        console.log(response)
        if(response['data']['status']==1){
          setCreateEduStatus('1')
          props.data(response['data']['status'])
          alert(response['data']['msg'])

          if(createEduStatus=='0'){
            $('.show_table_getDetailsEmployment').append('<table class="table-wrapper">'+
            '<thead>'+
            '<tr>'+
            '<th scope="col">S.No.</th>'+
            '<th scope="col">Office/Organisation</th>'+
            '<th scope="col">Post held</th>'+
            '<th scope="col">From</th>'+
            '<th scope="col">To</th>'+
            '<th scope="col">Scale of Pay</th>'+
            '<th scope="col">Nature of duties</th>'+
            '<th colspan="2" scope="col">Action</th>'+
            '</tr>'+
            '</thead>'+
          '</table>')
          }
      
          $('.show_table_getDetailsEmployment').append('<table class="table-wrapper">'+
          '<tbody>'+
          '<tr id="row_'+initialization +'">'+
          '<th scope="row">'+ initialization +'</th>'+
          '<td colspan="2">'+formdataCreateDetailsEmployment.office_name+'</td>'+
          '<td>'+formdataCreateDetailsEmployment.post_held+'</td>'+
          '<td>'+formdataCreateDetailsEmployment.employment_from+'</td>'+
          '<td>'+formdataCreateDetailsEmployment.employment_to+'</td>'+
          '<td colspan="2">'+formdataCreateDetailsEmployment.scale_of_pay+'</td>'+
          '<td colspan="2">'+formdataCreateDetailsEmployment.nature_of_duties+'</td>'+
          '<td colspan="2"><a id="edu_'+ initialization +'" class="btn btn-danger">Delete</a></td>'+
          '</tr>'+
          '</tbody>'+
          '</table>')
          document.querySelector('#edu_'+ initialization).addEventListener('click',()=>{
      
            axios.post(environment.apiUrl+"/Experience/deleteDetailsEmployment",JSON.stringify({dtls_employment_id:response.data.data_id}),{headers:(options.headers)})
            .then((response)=>{
              if(response.data.status==1){
                $('#row_'+initialization).hide()
                alert("Details of the employment deleted successfully")
              }
            })
        
          } )
          setInitialization(initialization+1)
        }else{
          alert(response['data']['msg'])
        }
      }) 
    }
    
  }
 
  function handleCreateDetailsEmploymentForm(e){
    e.preventDefault();
    formdataCreateDetailsEmployment.user_id=parseInt(sessionStorage.getItem("user_id"));
    formdataCreateDetailsEmployment.office_name=e.target.office_name.value;
    formdataCreateDetailsEmployment.post_held=e.target.post_held.value;
    formdataCreateDetailsEmployment.employment_from=e.target.employment_from.value;
    formdataCreateDetailsEmployment.employment_to=e.target.employment_to.value;
    formdataCreateDetailsEmployment.scale_of_pay=e.target.scale_of_pay.value;
    formdataCreateDetailsEmployment.nature_of_duties=e.target.nature_of_duties.value;
   
    setFormDataCreateDetailsEmployment(...[formdataCreateDetailsEmployment]);

    CreateDetailsEmployment()
    
  }



  const CreateACPDetailsEmployment=()=>{
   
    if(formdataCreateACPDetailsEmployment.office_name!=='' && formdataCreateACPDetailsEmployment.post_held!=='' && formdataCreateACPDetailsEmployment.employment_from!=='' && formdataCreateACPDetailsEmployment.employment_to!=='' && formdataCreateACPDetailsEmployment.scale_of_pay!=='' && formdataCreateACPDetailsEmployment.nature_of_duties!==''){
      axios.post(environment.apiUrl+"/Experience/CreateACPDetailsEmployment",JSON.stringify(formdataCreateACPDetailsEmployment),{headers:(options.headers)})
      .then((response)=>{
        if(response['data']['status']==1){
          setCreateEduStatus('1')
          props.data(response['data']['status'])
          alert(response['data']['msg'])

          if(createEduStatus=='0'){
            $('.show_table_getACPDetailsEmployment').append('<table class="table-wrapper">'+
            '<thead>'+
            '<tr>'+
            '<th scope="col">S.No.</th>'+
            '<th scope="col">S.No.</th>'+
          '<th scope="col">Office/ Institution</th>'+
          '<th scope="col">Pay-band and Grade Pay drawn under ACP/MACP scheme</th>'+
          '<th scope="col">From</th>'+
          '<th scope="col">To</th>'+
            '<th colspan="2" scope="col">Action</th>'+
            '</tr>'+
            '</thead>'+
          '</table>')
          }
      
          $('.show_table_getACPDetailsEmployment').append('<table class="table-wrapper">'+
          '<tbody>'+
          '<tr id="rowacp_'+initializationACP +'">'+
          '<th scope="row">'+ initializationACP +'</th>'+
          '<td colspan="2">'+formdataCreateACPDetailsEmployment.acp_office_name+'</td>'+
          '<td>'+formdataCreateACPDetailsEmployment.acp_post_held+'</td>'+
          '<td>'+formdataCreateACPDetailsEmployment.acp_from+'</td>'+
          '<td>'+formdataCreateACPDetailsEmployment.acp_to+'</td>'+
         
          '<td colspan="2"><a id="eduacp_'+ initializationACP +'" class="btn btn-danger">Delete</a></td>'+
          '</tr>'+
          '</tbody>'+
          '</table>')
          document.querySelector('#eduacp_'+ initializationACP).addEventListener('click',()=>{
      
            axios.post(environment.apiUrl+"/Experience/deleteACPDetailsEmployment",JSON.stringify({dtls_acp_employment_id:response.data.data_id}),{headers:(options.headers)})
            .then((response)=>{
              if(response.data.status==1){
                $('#rowacp_'+initializationACP).hide()
                alert("Details of ACP/MACP employment deleted successfully")
              }
            })
        
          } )
          setInitializationACP(initializationACP+1)
        }else{
          alert(response['data']['msg'])
        }
      }) 
    }
    
  }
 
  function handleCreateACPDetailsEmploymentForm(e){
    e.preventDefault();
    formdataCreateACPDetailsEmployment.user_id=parseInt(sessionStorage.getItem("user_id"));
    formdataCreateACPDetailsEmployment.acp_office_name=e.target.acp_office_name.value;
    formdataCreateACPDetailsEmployment.acp_post_held=e.target.acp_post_held.value;
    formdataCreateACPDetailsEmployment.acp_from=e.target.acp_from.value;
    formdataCreateACPDetailsEmployment.acp_to=e.target.acp_to.value;
    
    setFormDataCreateACPDetailsEmployment(...[formdataCreateACPDetailsEmployment]);

    CreateACPDetailsEmployment()
    
  }



  const handleFormValidation=()=>{
   if(formdata.nature_of_present_employment==''){
    alert("Nature of Present employment is required")
   }else if(formdata.addtnl_dtls_about_present_employment==''){
    alert("Additional details about present employment is required")
   }else if(formdata.addtnl_dtls_about_prsnt_employer_name==''){
    alert("Additional details about present employer name is required")
   }else if(formdata.state_deputation_absorption==''){
    alert("deputation/absorption (Officers under Central/State Governments are only eligible for “Absorption”) is required")
   }else{
    if(formdata.nature_of_present_employment!=='' && formdata.addtnl_dtls_about_present_employment!=='' && formdata.addtnl_dtls_about_prsnt_employer_name!=='' && formdata.state_deputation_absorption!==''){
      axios.post(environment.apiUrl+"/Experience/CreateUpdate",JSON.stringify(options.data.formdata),{headers:(options.headers)})
      .then((response)=>{
        if(response['data']['status']==1){
          setCreateEduStatus('1')
          props.data(response['data']['status'])
          alert(response['data']['msg'])

         
        }else{
          alert(response['data']['msg'])
        }
      }) 
    }
    
   }
    
  }

  

  function handleFormSubmit(e){
    e.preventDefault();
    formdata.user_id=parseInt(sessionStorage.getItem("user_id"));
    formdata.date_of_initial_appointment=e.target.date_of_initial_appointment.value;
    formdata.period_of_appointment=e.target.period_of_appointment.value;
    formdata.office_applicant_belongs=e.target.office_applicant_belongs.value;
    formdata.name_and_pay_of_post=e.target.name_and_pay_of_post.value;
    formdata.last_deputation_detail=e.target.last_deputation_detail.value;
    formdata.nature_of_present_employment=e.target.nature_of_present_employment.value;
    formdata.addtnl_dtls_about_present_employment=e.target.addtnl_dtls_about_present_employment.value;
    formdata.addtnl_dtls_about_prsnt_employer_name=e.target.addtnl_dtls_about_prsnt_employer_name.value;
    formdata.addtnl_dtls_about_present_employment_other=e.target.addtnl_dtls_about_present_employment_other.value;
    formdata.additional_information=e.target.additional_information.value;
    formdata.state_deputation_absorption=e.target.state_deputation_absorption.value;
    formdata.sc_st_category=e.target.sc_st_category.value;
    setFormData(...[formdata]);

    handleFormValidation()
    
  }



const getACPDetailsEmployment=()=>{
    
  axios.post(environment.apiUrl+"/Experience/getACPDetailsEmployment",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
  .then((response)=>{
   
    if(response['data']['status']==1){
      console.log("getACPDetailsEmployment")
      console.log(response.data.data[0]['id'])
      setInitializationACP(initializationACP+response.data.data.length)
      setCreateEduStatus('1')
      props.data(response['data']['status'])
      setData({
        ...data,data:response['data']
      })
     
        if(createEduStatus=='0'){
        
          $('.show_table_getACPDetailsEmployment').append('<table class="table-wrapper">'+
          '<thead>'+
          '<tr>'+
          '<th scope="col">S.No.</th>'+
          '<th scope="col">Office/ Institution</th>'+
          '<th scope="col">Pay-band and Grade Pay drawn under ACP/MACP scheme</th>'+
          '<th scope="col">From</th>'+
          '<th scope="col">To</th>'+
       
          '<th scope="col">Action</th>'+
          '</tr>'+
          '</thead>'+
        '</table>')
       
        }
        
       // if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
        for(let i=0;i<response.data.data.length;i++){
          setDataLength(i)
          $('.show_table_getACPDetailsEmployment').append('<table class="table-wrapper">'+
          '<tbody>'+
          '<tr id="rowacp_'+i+'">'+
          '<th scope="row">'+ initializationACP++ +'</th>'+
          '<td>'+response.data.data[i]['acp_office_name']+'</td>'+
           '<td>'+response.data.data[i]['acp_post_held']+'</td>'+
           '<td>'+response.data.data[i]['acp_from']+'</td>'+
           '<td>'+response.data.data[i]['acp_to']+'</td>'+
           
          '<td><a id="eduacp_'+ i +'" class="btn btn-danger">Delete</a></td>'+
          '</tr>'+
          '</tbody>'+
          '</table>')
         
      }
  //  }
      for(let i=0;i<response.data.data.length;i++){
        setDataLength(i+2)
      document.querySelector('#eduacp_'+i).addEventListener('click',()=>{
        let a=i;
        axios.post(environment.apiUrl+"/Experience/deleteACPDetailsEmployment",JSON.stringify({dtls_acp_employment_id:response.data.data[0]['id']}),{headers:(options.headers)})
        .then((response)=>{
          if(response.data.status==1){
            $('#rowacp_'+a).hide()
            alert("Details of ACP/MACP employment deleted successfully")
          }
        })
    
      } )
      }
    }
  })
}

  const getDetailsEmployment=()=>{
    
    axios.post(environment.apiUrl+"/Experience/getDetailsEmployment",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
    .then((response)=>{
     
      if(response['data']['status']==1){
        setInitialization(initialization+response.data.data.length)
        setCreateEduStatus('1')
        props.data(response['data']['status'])
        setData({
          ...data,data:response['data']
        })
       
          if(createEduStatus=='0'){
          
            $('.show_table_getDetailsEmployment').append('<table class="table-wrapper">'+
            '<thead>'+
            '<tr>'+
            '<th scope="col">S.No.</th>'+
            '<th scope="col">Office/Organisation</th>'+
            '<th scope="col">Post held</th>'+
            '<th scope="col">From</th>'+
            '<th scope="col">To</th>'+
            '<th scope="col">Scale of Pay</th>'+
            '<th scope="col">Nature of Duties</th>'+
            '<th scope="col">Action</th>'+
            '</tr>'+
            '</thead>'+
          '</table>')
         
          }
          
         // if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
          for(let i=0;i<response.data.data.length;i++){
            setDataLength(i)
            $('.show_table_getDetailsEmployment').append('<table class="table-wrapper">'+
            '<tbody>'+
            '<tr id="row_'+i+'">'+
            '<th scope="row">'+ initialization++ +'</th>'+
            '<td>'+response.data.data[i]['office_name']+'</td>'+
             '<td>'+response.data.data[i]['post_held']+'</td>'+
             '<td>'+response.data.data[i]['employment_from']+'</td>'+
             '<td>'+response.data.data[i]['employment_to']+'</td>'+
             '<td>'+response.data.data[i]['scale_of_pay']+'</td>'+
             '<td>'+response.data.data[i]['nature_of_duties']+'</td>'+
            '<td><a id="edu_'+ i +'" class="btn btn-danger">Delete</a></td>'+
            '</tr>'+
            '</tbody>'+
            '</table>')
           
        }
    //  }
        for(let i=0;i<response.data.data.length;i++){
          setDataLength(i+2)
        document.querySelector('#edu_'+i).addEventListener('click',()=>{
          let a=i;
          axios.post(environment.apiUrl+"/Experience/deleteDetailsEmployment",JSON.stringify({dtls_employment_id:response.data.data[0]['id']}),{headers:(options.headers)})
          .then((response)=>{
            if(response.data.status==1){
              $('#row_'+a).hide()
              alert("Details of the employment deleted successfully")
            }
          })
      
        } )
        }
      }
    })
  }
  
  function getExperienceDetails(){
    axios.post(environment.apiUrl+"/Experience/getExperienceDetails",JSON.stringify({user_id:sessionStorage.getItem("user_id")}),{headers:options.headers})
    .then((response)=>{
      if(response.data.status==1){
        if((response.data.data['addtnl_dtls_about_present_employment'])=="Others"){
          $("#addtnl_dtls_about_present_employment_other").show();
        }else{
          $("#addtnl_dtls_about_present_employment_other").hide();
        }
        setFormData({
          date_of_initial_appointment:response.data.data['date_of_initial_appointment'],
          period_of_appointment:response.data.data['period_of_appointment'],
          office_applicant_belongs:response.data.data['office_applicant_belongs'],
          name_and_pay_of_post:response.data.data['name_and_pay_of_post'],
          last_deputation_detail:response.data.data['last_deputation_detail'],
          nature_of_present_employment:response.data.data['nature_of_present_employment'],
          addtnl_dtls_about_present_employment:response.data.data['addtnl_dtls_about_present_employment'],
          addtnl_dtls_about_prsnt_employer_name:response.data.data['addtnl_dtls_about_prsnt_employer_name'],
          addtnl_dtls_about_present_employment_other:response.data.data['addtnl_dtls_about_present_employment_other'],
          additional_information:response.data.data['additional_information'],
          state_deputation_absorption:response.data.data['state_deputation_absorption'],
          sc_st_category:response.data.data['sc_st_category']
        })
      }
      // if(response){

      // }
    })
  }
  function fromDateChangeCreateDtls(event: any) {
 
    setMaxFromDate(document.getElementById("employment_from").value)
  }
  function fromDateChangeACP(event: any) {
 
    setMaxFromDate(document.getElementById("acp_from").value)
  }
  function hide_show_others_field(e){
    console.log(document.getElementById("addtnl_dtls_about_present_employment").value)
    if((document.getElementById("addtnl_dtls_about_present_employment").value)=="Others"){
      $("#addtnl_dtls_about_present_employment_other").show();
    }else{
      $("#addtnl_dtls_about_present_employment_other").hide();
    }
  }
  useEffect((e)=>{
    if(apiCall==0){
      getDetailsEmployment()
      getACPDetailsEmployment()
      getExperienceDetails()
      hide_show_others_field(e)
      //props.data(1)
    }
    setApiCall(1)
   },[apiCall,props,getDetailsEmployment,getACPDetailsEmployment,getExperienceDetails])

  return (
    <>
     <div className="container-fluid page-body-wrapper">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Work Experience</h4>
                        <p className="card-description"> Fill the work experience to proceed </p>
                        <form onSubmit={(e)=>handleCreateDetailsEmploymentForm(e)}>
                            <div className="row">
                                <h5>Details of the employment in chronological order. Enclose a separate sheet duly authenticated by your signature, if the space below is insufficient</h5>
                                <div className="form-group col-2">
                                    <label>Office/Organisation <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="office_name" id="exampleInputName1" placeholder="Office/Organisation"/>
                                </div>
                                <div className="form-group col-2">
                                  <label>Post held <span className="text-danger">*</span></label>
                                  <input type="text" className="form-control" name="post_held" id="exampleInputName1" placeholder="Post held"/>
                              </div>
                              <div className="form-group col-2">
                                <label>From <span className="text-danger">*</span></label>
                                <input type="date" min={minFromDate} max={minToDate} onChange={(e)=>fromDateChangeCreateDtls(e)} className="form-control" name="employment_from" id="employment_from" placeholder="From"/>
                            </div>
                            <div className="form-group col-2">
                              <label>To <span className="text-danger">*</span></label>
                              <input type="date" min={maxFromDate} max={maxToDate} className="form-control" name="employment_to" id="employment_to" placeholder="To"/>
                          </div>
                          <div className="form-group col-2">
                            <label>Scale of Pay <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" name="scale_of_pay" id="exampleInputName1" placeholder="Scale of Pay"/>
                        </div>
                        <div className="form-group col-2">
                          <label>Nature of duties <span className="text-danger">*</span></label>
                          <input type="text" maxLength={120} className="form-control" name="nature_of_duties" id="exampleInputName1" placeholder="Nature of duties"/>
                      </div>
                      
                  </div>
                  <div className="row">
                    <div className="col-2">
                      <button type="submit" style={{width:'100px'}} className="btn btn-primary me-2">Add</button>
                      
                    </div>
                  </div>
                  <br/>
                  <div className="show_table_getDetailsEmployment">
                          
                  </div>
                  </form>
                  <form onSubmit={(e)=>handleCreateACPDetailsEmploymentForm(e)}>
               
                  <br/>
                  <div className="row">
                    <label>*Important: Pay-band and Grade Pay granted under ACP/MACP are personal to the officer and therefore, should not be mentioned. Only pay band and grade pay/ pay scale of the post held on regular basis to be mentioned. Details of ACP/MACP with present Pay Band and Grade Pay where such benefits have been drawn by the Candidate, may be indicated below:</label>
                    <div className="row">
                      <div className="col-12">
                        <br/>
                      </div>
                    </div>
                    <div className="form-group col-3"> 
                      <label>Office/ Institution <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name="acp_office_name" id="exampleInputName1" placeholder="Office/Organisation"/>
                  </div>
                  <div className="form-group col-3">
                    <label>Pay-band and Grade Pay drawn under ACP/MACP scheme <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" name="acp_post_held" id="exampleInputName1" placeholder="Post held"/>
                </div>
                <div className="form-group col-3">
                  <label>From <span className="text-danger">*</span></label>
                  <input type="date" min={minFromDate} max={minToDate} onChange={(e)=>fromDateChangeACP(e)} className="form-control" name="acp_from" id="acp_from" placeholder="From"/>
              </div>
              <div className="form-group col-3">
                <label>To <span className="text-danger">*</span></label>
                <input type="date" min={maxFromDate} max={maxToDate} className="form-control" name="acp_to" id="acp_to" placeholder="To"/>
            </div>
                 </div> 
                  <div className="row">
                    <div className="col-2">
                    <button type="submit" style={{width:'100px'}} className="btn btn-primary me-2">Add</button>
                    
                    </div>
                  </div> <br/>
                  <div className="show_table_getACPDetailsEmployment">
                          
                  </div>
                  </form>
                        <form className="forms-sample" onSubmit={handleFormSubmit}>	
                          
                 
                  <div className="row">
                    <div className="col-6">
                      <label>Nature of Present employment <span className="text-danger">*</span></label>
                      <select className="form-select" value={(formdata.nature_of_present_employment) || ''} onChange={(e)=>setFormData({...formdata,nature_of_present_employment:(e.target.value)})} name="nature_of_present_employment">
                        <option value="">Select Nature of Present employment</option>
                        <option value="Ad-hoc">Ad-hoc</option>
                        <option value="Temporary">Temporary</option>
                        <option value="Quasi Permanent">Quasi Permanent</option>
                        <option value="Permanent">Permanent</option>
                      </select>
                    </div>
                    
                  </div>
                  <br/>
                  <div className="row">
                    <div className="col-12">
                      <h5 style={{textAlign: 'left'}}>In case the present employment is held on deputation/contract basis, please state -</h5>
                    </div>
                  
                  </div>
                  <div className="row">
                    <div className="col-3" style={{textAlign:'left', fontSize:'12px'}}>
                      <label>Date of initial appointment <span className="text-danger">*</span></label><br/><br/>
                      <input type="date" defaultValue={formdata.date_of_initial_appointment} name="date_of_initial_appointment" className="form-control" id="exampleInputName1" placeholder="Date of initial appointment"/>
                    </div>
                    <div className="col-3" style={{textAlign:'left', fontSize:'12px'}}>
                      <label>Period of appointment on deputation/contract <span className="text-danger">*</span></label><br/><br/>
                      <input type="text" defaultValue={formdata.period_of_appointment} name="period_of_appointment" className="form-control" id="exampleInputName1" placeholder="Period of appointment on deputation/contract"/>
                    </div>
                    <div className="col-3" style={{textAlign:'left', fontSize:'12px'}}>
                      <label>Name of the Parent office/organisation to which the applicant belongs <span className="text-danger">*</span></label>
                      <input type="text" defaultValue={formdata.office_applicant_belongs} name="office_applicant_belongs" className="form-control" id="exampleInputName1" placeholder="Name of the Parent office/organisation to which the applicant belongs"/>
                    </div>
                    <div className="col-3" style={{textAlign:'left', fontSize:'12px'}}>
                      <label>Name of the post and Pay of the post held in substantive capacity in the parent Organisation <span className="text-danger">*</span></label>
                      <input type="text" defaultValue={formdata.name_and_pay_of_post} name="name_and_pay_of_post" className="form-control" id="exampleInputName1" placeholder="Name of the post and Pay of the post held in substantive capacity in the parent organisation"/>
                    </div>
                  </div><br/>
                  <div className="row">
                    <div className="col-12" style={{textAlign:'left'}}>
                      <h6>Note 1 – In case of officers already on deputation, the applications of such officers should be forwarded by the parent cadre/ Department along with Cadre Clearance, Vigilance Clearance and integrity certificate</h6>
                    </div>
                    <div className="col-12" style={{textAlign:'left'}}>
                      <h6>Note 2 – Information under column 15 (c) and (d) above must be given in all cases where a person is holding a post on deputation outside the cadre/organisation but still maintaining a lien in his parent cadre/organisation. </h6>
                    </div>
                  </div><br/>
                  <div className="row">
                    <div className="col-6" style={{textAlign:'left'}}>
                      <label>If any post held on deputation in the past by the applicant, date of return from the last deputation and other details <span className="text-danger">*</span></label>
                      <input type="text" maxLength={240} defaultValue={formdata.last_deputation_detail} name="last_deputation_detail" className="form-control" id="exampleInputName1" placeholder="If any post held on deputation in the past by the applicant, date of return from the last deputation and other details"/>
                    </div><br/>
                    
                  </div>
                  <div className="row">
                    <div className="col-9" style={{textAlign:'left'}}>
                      <br/>
                      <h6>Additional details about present employment –</h6>
                      <label>Please state whether working under (include the name of your employer against the relevant column) <span className="text-danger">*</span></label>
                      <div className="row">
                        <div className="col-3"><br/>
                          <select className="form-select" id="addtnl_dtls_about_present_employment" value={formdata.addtnl_dtls_about_present_employment || ''} onChange={(e)=>{
                            setFormData({...formdata,addtnl_dtls_about_present_employment:e.target.value})
                            hide_show_others_field(e.target.value)
                            }}  name="addtnl_dtls_about_present_employment">
                          <option value="">Select Present employment</option>
                            <option value="Central Government">Central Government</option>
                            <option value="State Government">State Government</option>
                            <option value="Autonomous Organisation">Autonomous Organisation</option>
                            <option value="Government Undertaking">Government Undertaking</option>
                            <option value="Others">Others (Pls specify)</option>
                          </select><br/>
                         
                        </div>
                        <div className="col-6"><br/>
                          <input type="text" defaultValue={formdata.addtnl_dtls_about_prsnt_employer_name} name="addtnl_dtls_about_prsnt_employer_name" className="form-control" id="exampleInputName1" placeholder="Please specify name of your present employer"/>
                        </div>
                      </div>
                      
                    
                      <div className="col-6" style={{marginLeft:'-12px'}}>
                        <input type="text" defaultValue={formdata.addtnl_dtls_about_present_employment_other} name="addtnl_dtls_about_present_employment_other" className="form-control" id="addtnl_dtls_about_present_employment_other" placeholder="Specify in case of others"/><br/>
                        </div>
                    </div>
                    
                  </div>
                  <div className="row">
                    <div className="col-4" style={{textAlign:'left'}}>
                      <label>Additional information, if any, which you would like to mention in support of your suitability for the post <span className="text-danger">*</span></label>
                      <textarea className="form-control" defaultValue={formdata.additional_information} name="additional_information" id="exampleInputName1" placeholder="Additional information"></textarea>
                    </div>
                    <div className="col-4" style={{textAlign:'left'}}>
                      <label>Whether belongs to SC/ST</label><br/><br/>
                      <select className="form-select" name="sc_st_category" value={formdata.sc_st_category || ''} onChange={(e)=>setFormData({...formdata,sc_st_category:e.target.value})}>
                      <option value="">Select category</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                    <div className="col-4" hidden={true}>
                      <label>Please state whether you are applying for deputation/absorption (Officers under Central/State Governments are only eligible for “Absorption”). <span className="text-danger">*</span></label>
                      {/* <input type="text" className="form-control" defaultValue={formdata.state_deputation_absorption} name="state_deputation_absorption" id="exampleInputName1" placeholder="Please state whether you are applying for deputation/absorption"/> */}
                      <input type="text" className="form-control" value="state_deputation_absorption" name="state_deputation_absorption" id="exampleInputName1" placeholder="Please state whether you are applying for deputation/absorption"/>
                    </div>
                  </div><br/>
                  <div className="row">
                    
                  </div><br/><br/>
                          
                          <button type="submit" style={{width:'100px'}} className="btn btn-primary me-2">Save</button>
                         
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
            
    </>
  )
}

export default WorkExperience